import { ENDPOINT_ROOT } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const getWarehouses = ({ queryKey: [endpoint, company, code] }) => {
  let url = `${ENDPOINT_ROOT}/${endpoint}/${company}`;

  if (code) {
    url = `${url}/${code}`;
  }

  return axiosAuth.get(url).then((res) => res.data);
};

export default getWarehouses;
